module.exports = __webpack_public_path__ + "img/item9.3660f8a9.jpg";